<script setup lang="ts">
import type NewsItem from '@/types/NewsItem.ts'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'

const props = defineProps<{
  newsItem: NewsItem
  toast: boolean
}>()
</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="props.newsItem.contentData.profileImage"
    :toast-text="props.newsItem.contentData.nickname + ' wants to chat with you!'"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="props.newsItem.contentData.profileImage"
      :header="'New chat with ' + props.newsItem.contentData.nickname + '!'"
    >
      {{ props.newsItem.contentData.nickname }} wants to communicate with you.
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss"></style>
